var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 1.59998C11.5348 1.59998 14.4001 4.46526 14.4001 7.99998C14.4001 11.5347 11.5348 14.4 8.0001 14.4C4.46538 14.4 1.6001 11.5347 1.6001 7.99998C1.6001 4.46526 4.46538 1.59998 8.0001 1.59998ZM10.763 5.9571C10.6933 5.88744 10.6004 5.84594 10.502 5.84057C10.4036 5.8352 10.3067 5.86632 10.2299 5.92798L10.1972 5.9571L6.9601 9.19422L5.80298 8.0371C5.73064 7.96474 5.63333 7.92285 5.53106 7.92004C5.42878 7.91723 5.32932 7.95372 5.25313 8.02201C5.17694 8.09029 5.12981 8.18517 5.12143 8.28714C5.11305 8.38911 5.14407 8.49041 5.2081 8.57022L5.23722 8.60286L6.67722 10.0429C6.74689 10.1125 6.83983 10.154 6.93821 10.1594C7.03659 10.1648 7.13349 10.1336 7.21034 10.072L7.24298 10.0429L10.763 6.52286C10.8001 6.48571 10.8296 6.44161 10.8497 6.39307C10.8698 6.34454 10.8802 6.29251 10.8802 6.23998C10.8802 6.18744 10.8698 6.13542 10.8497 6.08688C10.8296 6.03834 10.8001 5.99424 10.763 5.9571Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8f76580ae2c899e5fffcba4a3d86d060.svg";
export { ForwardRef as ReactComponent };